var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AmetrasTextAreaFieldTemplate',_vm._g(_vm._b({attrs:{"value":_vm.internalValue}},'AmetrasTextAreaFieldTemplate',_vm.attrs$,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }